<template>
  <v-row class="border ma-0 pa-2 c-medication-adherence">
    <v-col cols="2" align-self="center">
      <medication-adherence-icon
        :color="color"
        :text="colorText"
      />
    </v-col>
    <v-col cols="8" align-self="center">
      <span v-if="!!text" class="c-medication-adherence__text">
        {{ text }}
      </span>
      <span v-else>
        {{ $ucfirst($t('noData')) }}
      </span>
    </v-col>
    <v-col cols="2" align="center">
      <p class="c-medication-adherence__reported-on" v-if="date">
        {{$ucfirst($t('pa.reportedOn'))}} {{date}}
      </p>
    </v-col>
  </v-row>
</template>

<script>
import gql from 'graphql-tag';
import moment from 'moment';
import MedicationAdherenceIcon from "./MedicationAdherenceIcon";
import { mapGetters } from 'vuex';

/**
 * Component MedicationAdherence.vue
 *
 * @module MedicationAdherence
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.6] app/src/APP_DASHBOARD/templates/components/Parts/MedicationAdherence.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "MedicationAdherence",
  components: {
    MedicationAdherenceIcon,
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
  },
  data: function(){
    return {
      text: "",
      color: "",
      colorText: "",
      date: "",
    }
  },
  mounted: function(){
    this.getMedicationAherence();
  },
  methods: {
    getMedicationAherence: function() {
      this.$app.apolloMobileClient
        .query({
          query: gql`
            query myQuestionnaireForms(
              $patientId: String!
            ) {
              myQuestionnaireForms(
                functions: {function: patientId, parameters: [$patientId]}
                conditions : {gate : and, inputs : [
                  {field : completed, value : "1"},
                  {field : key, value : "MA"},
                ]},
                orders : {field : formEntryDate, direction : desc}
                limit: 1
              ) {
                entryDate
                entries{
                  givenAnswers{
                    key
                    score
                    text
                  }
                }
              }
            }
          `,
          variables: {
            patientId: this.patientId,
          },
        })
        .then((result) => {
          if (!result.data.myQuestionnaireForms.length) return

          this.text = result.data.myQuestionnaireForms[0].entries[0].givenAnswers[0].text;

          this.date = moment(result.data.myQuestionnaireForms[0].entryDate).format('DD/MM/YYYY');

          if(result.data.myQuestionnaireForms[0].entries[0].givenAnswers[0].score < 3) {
            this.color = this.$color.coro['danger-500'];
            this.colorText = this.$ucfirst(this.$t('expertTool.intensity.L.long'));
          } else if(result.data.myQuestionnaireForms[0].entries[0].givenAnswers[0].score < 5) {
            this.color = this.$color.coro['warning-500'];
            this.colorText = this.$ucfirst(this.$t('caregiverDashboardRiskProfile.medium'));
          } else {
            this.color = this.$color.coro['success-500'];
            this.colorText = this.$ucfirst(this.$t('medication.highAdherenceCapital'));
          }
        });
    }
  }
};
</script>

<style lang="scss">
.c-medication-adherence {
  height: 100%;
}
.c-medication-adherence__text {
  font-size: 1.2em;
  font-weight: 500;
}
.c-medication-adherence__reported-on{
  font-size: 0.9em;
}
</style>
